<template>
  <div class="animated fadeIn">
  
    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3" v-if="can('guichet-create')">
          <router-link to="/guichets/create/agence/null">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
      <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
        <div>
          <vue-good-table :columns="columns" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search">
            <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'btn'">                       
                            
                              <b-dropdown id="ddown-sm-split" size="sm" split text="Plus de détails" class="m-2">
                                <div role="group" aria-lableledby="header1">                   
                                    <router-link :to="'guichets/edit/' + props.row.id" v-if="can('guichet-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                        <!-- <b-dropdown-item-button aria-describedby="header1" v-if="can('guichet-delete')"><i class="fa fa-trash"></i> Supprimer</b-dropdown-item-button>
                                    <router-link :to="'guichets/show/' + props.row.id" v-if="can('guichet-show')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                                </div>
                                <div role="group" aria-lableledby="header2">
                                  <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>
                                    <router-link :to="'/historique/guichet/'+ props.row.id">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                                    </router-link>
                                    <router-link :to="'approvisionnements/guichet/create/'+ props.row.id" v-if="can('approvisionnement-create-by-guichet')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Approvisionner</b-dropdown-item-button>
                                    </router-link>
                                    <router-link :to="'operations/transfert/envoi/guichet/create/'+ props.row.id" v-if="can('operation-transfert-envoi-create')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Transfert d'argent (Envoi)</b-dropdown-item-button>
                                    </router-link>
                                    <router-link :to="'operations/transfert/retrait/guichet/create/'+ props.row.id" v-if="can('operation-transfert-retrait-create')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Transfert d'argent (Retrait)</b-dropdown-item-button>
                                    </router-link>
                                    <router-link :to="'operations/paiement_masse/guichet/create/'+ props.row.id" >
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Paiement de masse</b-dropdown-item-button>
                                    </router-link>
                                    <router-link :to="'plannings/guichet/create/'+ props.row.id" v-if="can('planning-create')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Plannings</b-dropdown-item-button>
                                    </router-link>
                                  <!--<b-dropdown-item-button aria-describedby="header2">Delete</b-dropdown-item-button>-->
                                </div>
                              </b-dropdown>
                           
                        </span>
                        <span v-else>
                          {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>
</template>

<script>
  //import cTableEntities from './TableEntities.vue'
  import {
    VueGoodTable
  } from 'vue-good-table';
  import {
    mapState,
    mapActions
  } from 'vuex';
  export default {
    name: 'tables',
    //components: {cTableEntities},
    components: {
      VueGoodTable
    },
    data() {
      return {
        columns: [{
            label: 'Agence',
            field: 'agence',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Nom',
            field: 'nom',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Solde',
            field: 'solde',
            type: 'number',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Enregistré le',
            field: 'created_at',
            type: 'date',
            dateInputFormat: 'YYYY-MM-DD',
            dateOutputFormat: 'YYYY-MM-DD',
            formatFn: this.formatFn,
            filterable: true,
            thClass: 'custom-th-class',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Action',
            field: 'btn',
            html: true,
            width: '150px',
          }
        ],
        rows: [],
        pagination: {
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3, 5, 10, 50, 100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search: {
          enabled: true,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
        }
      };
    },
    computed: mapState({
      agencies: state => state.atm.all
    }),
    created() {
      
      
    },
    methods: {
      formatFn: function (value) {
          return value != null ? value : null
      },
      async get_all_atms() {
        this.$store.dispatch('atm/get_all_atms').then(()=>{
          return this.rows = store.getters['atm/rows'];
        })
      },
      can(perm){
            return store.getters['auth/can'](perm)
        }
    },
    mounted() {
      this.get_all_atms()
    }
  
  }
</script>
